import { createContext } from 'react'

import defaultProperties from './defaultProperties'

const UserContext = createContext(
{
    ...defaultProperties
});

export default UserContext ;